import { GatewayDetailsList, GatewayListData } from '../types/gateway';
import { DeviceList, DeviceListData } from '../types/device';
import { LuminaryListData } from '../types/luminary';
import { BaseCustomerDetail, DeviceCustomerDetail } from '../types/customer-detail';
import { SLADataList, SLAListData } from '../types/sla';
import { slaCustomerList } from '../types/sla-customer-details';
import { string } from 'yargs';
import { MaintenanceTicketDetailListData } from '../types/maintenance-ticket';
import { FirePanelListData } from '../types/firepanel';
import { ConfigureLuminaryDetailsList } from '../types/configure-luminaries-list-types';
import { GetIOConfigDetailsOkResponse, SetIOConfigurationOkResponse } from '../api/types';

const defaultLumListData: LuminaryListData = {
    detail: [],
    totalRecordCount: 0,
    totalPage: 0,
    totalReadyCount: 0,
    totalFailedLuminairesCount: 0
}
export type WhiteListZone = {
    id: string | number;
    name: string;
    description: string;
    luminariesCount: number;
};
export type WhitelistZoneData = {
    systemName: string | null;
    projectId: string | null;
    buildingId: string | null;
    systemId: string | null;
    whitelistId: string;
    whitelistName: string;
    zones: WhiteListZone[];
};

export const defaultWhitelistZoneData: WhitelistZoneData = {
    systemName: '',
    projectId: '',
    buildingId: '',
    systemId: '',
    whitelistId: '',
    whitelistName: '',
    zones: []
};

export const defaultGetIOConfigDetailsOkResponse: GetIOConfigDetailsOkResponse = {
  message: '',
  data: {
    whitelistId: '',
    projectId: '',
    buildingId: '',
    systemId: '',
    whitelistName: '',
    systemName: '',
    inputConfig: [],
    outputConfig: [],
    s1s2Name: '',
    s1s2Description: '',
    s1s2Status: false,
  },
};

export type WhiteListDetail = {
    id: string;
    name: string;
    projectId: string;
    projectName: string;
    buildingId: string;
    buildingName: string;
    systemId: string;
    systemName: string;
    createdDate: string;
};

export const defaultWhiteListDetail: WhiteListDetail[] = [];
export const baseCustomerDetailState: BaseCustomerDetail = {
    companyName: '',
    customerNumber: '',
    companyAddress1: '',
    companyAddress2: '',
    city: '',
    country: '',
    postalCode: '',
    companyCountryCode: '',
    companyPhone: '',
    comments: '',
    primaryCountryCode: '',
    primaryFirstName: '',
    primaryLastName: '',
    primaryPhone: '',
    primaryCountryCode2: '',
    primaryPhone2: '',
    primaryEmail: '',
    primaryContactType: 0,
    primaryContactComments: '',
    secondaryFirstName: '',
    secondaryLastName: '',
    secondaryCountryCode: '',
    secondaryPhone: '',
    secondaryCountryCode2: '',
    secondaryPhone2: '',
    secondaryContactType: 0,
    secondaryContactComments: '',
    secondaryEmail: '',
    imageBase64: '',
    imageType: ''
};
export const customerData: DeviceCustomerDetail = {
    ...baseCustomerDetailState,
    customerId: '',
    sLACount: 0,
    expiryDate: '',
    systemId: '',
    systemCount: 0,
    buildingCount: 0,
    sLANumber: ''
};

const getSLAData: SLAListData = {
    detail: [{
        sLANumber: '',
        companyName: '',
        customerNumber: '0',
        customerCity: '',
        projectName: '',
        projectId: '0',
        buildingName: '',
        buildingId: '0',
        systemName: '',
        systemId: '0',
        type: 0,
        systemStatus: 0,
        luminariesNotPartOfSLA: '',
        expiryDate: '0001-01-01T00:00:00',
        serviceDueDate: '',
        serviceDueStatus: '',
        serviceType: 0,
        isFavorite: '',
        ticketCreatedDate: '',
        technicianName: '',
        technicianId: ''
    }],
    totalRecordCount: 0,
    totalPage: 0
}

const getMaintenanceTicketData: MaintenanceTicketDetailListData = {
    "detail": [
        {
            "organizationId": "9867d4bc-8afa-4527-8469-d9b9f80b5fbd",
            "organizationName": "DuelOrg",
            "customerName": "Don Bosco",
            "systemName": "Loading_DGS_A10",
            "systemStatus": 3,
            "technicianName": "",
            "systemLocation": "First Floor",
            "systemType": 0,
            "buildingId": "953b53c5-ba95-466f-b29f-45f47af807ac",
            "buildingName": "wing b",
            "isFavorite": "false",
            "completionDate": "2024-09-13T18:30:45Z",
            "id": "1e00aafa-e136-4fd1-a492-29e1b22d14d3",
            "systemId": "07397ccd-a079-4f39-b538-70c53be9234c",
            "customerId": "96770a9e-a5f8-4873-9c58-b0e2f5304245",
            "sLANumber": "987776765666",
            "requestPriority": 1,
            "serviceType": 1,
            "ticketStatus": 4,
            "ticketNumber": "MAINT3007241001",
            "assignedTo": "",
            "serviceDate": "2025-05-01T00:00:00Z",
            "description": "",
            "documents": undefined,
            "alarmLink": "https://eaton-corp.atlassian.net/brows/ELD-21484",
            "notes": undefined,
            "resolutions": null,
            "lastUpdatedDateTime": "2024-07-30T15:18:22Z",
        },
        {
            "organizationId": "9867d4bc-8afa-4527-8469-d9b9f80b5fbd",
            "organizationName": "DuelOrg",
            "customerName": "Don Bosco",
            "systemName": "TES data",
            "systemStatus": 6,
            "technicianName": "NormalUser DevTwo",
            "systemLocation": "First Floor",
            "systemType": 0,
            "buildingId": "1cb78dfc-6e9b-4d99-925c-8e8343baadf3",
            "buildingName": "Duel Wing 1",
            "isFavorite": "false",
            "completionDate": "",
            "id": "a1a032cf-8816-4eb2-bdb8-efbb19f5bed7",
            "systemId": "ce74f869-213b-40b0-902c-52d42dfa0ecf",
            "customerId": "96770a9e-a5f8-4873-9c58-b0e2f5304245",
            "sLANumber": "345656787887",
            "requestPriority": 2,
            "serviceType": 1,
            "ticketStatus": 1,
            "ticketNumber": "MAINT0807241000",
            "assignedTo": "320be590-c7ea-4677-ab93-3bbadeffb942",
            "serviceDate": "2025-07-13T05:22:00Z",
            "description": "",
            "documents": undefined,
            "alarmLink": "",
            "notes": undefined,
            "resolutions": null,
            "lastUpdatedDateTime": "2024-07-08T11:59:15Z",
        },
        {
            "organizationId": "9867d4bc-8afa-4527-8469-d9b9f80b5fbd",
            "organizationName": "DuelOrg",
            "customerName": "Don Bosco",
            "systemName": "TES data",
            "systemStatus": 6,
            "technicianName": "NormalUser DevTwo",
            "systemLocation": "First Floor",
            "systemType": 0,
            "buildingId": "1cb78dfc-6e9b-4d99-925c-8e8343baadf3",
            "buildingName": "Duel Wing 1",
            "isFavorite": "false",
            "completionDate": "",
            "id": "0be71109-a0a8-49a1-8d91-2cc65ad00912",
            "systemId": "ce74f869-213b-40b0-902c-52d42dfa0ecf",
            "customerId": "96770a9e-a5f8-4873-9c58-b0e2f5304245",
            "sLANumber": "345656787887",
            "requestPriority": 2,
            "serviceType": 1,
            "ticketStatus": 1,
            "ticketNumber": "MAINT0807241001",
            "assignedTo": "320be590-c7ea-4677-ab93-3bbadeffb942",
            "serviceDate": "2025-07-13T05:22:00Z",
            "description": "",
            "documents": undefined,
            "alarmLink": "",
            "notes": [
                {
                    "createdBy": "service Manager1",
                    "createdDateTime": "2024-09-27T07:56:17Z",
                    "note": "This is test note",
                    "noteId": "59205917-dba7-4b7c-9eba-8928fd42828c"
                }
            ],
            "resolutions": null,
            "lastUpdatedDateTime": "2024-07-08T11:59:33Z",
        },
    ],
    "totalRecordCount": 28,
    "totalPage": 3

};

const defaultGatewayListData: GatewayListData = {
    detail: [],
    totalRecordCount: 0,
    totalPage: 0
}
const defaultSystemListData: DeviceListData = {
    detail: [],
    totalRecordCount: 0,
    totalPage: 0
}

const defaultFirePanelListData: FirePanelListData = {
    detail: [],
    totalRecordCount: 0,
    totalPage: 0
}

export const defaultconfigureLumnListData: ConfigureLuminaryDetailsList = {
    whitelistName: "",
    systemId: "",
    systemName: null,
    luminaryConfigs: [],
    totalRecordCount: 0,
    totalPage: 0
}

export type AssetState = {
    deviceListLoading: boolean;
    deviceListSuccess: boolean;
    deviceListFail: boolean;
    deviceList: DeviceListData,
    deviceListErrorCode: string;

    whitelistzoneLoading: boolean;
    whitelistzoneSuccess: boolean;
    whitelistzoneFail: boolean;
    whitelistzoneErrorCode: string;
    whitelistZoneId: string;
    whitelistZoneMessage: string;

    deviceGetWhitelistZoneLoading: boolean;
    deviceGetWhitelistZoneSuccess: boolean;
    deviceGetWhitelistZoneFail: boolean;
    deviceGetWhitelistZone: WhitelistZoneData,
    deviceGetWhitelistZoneErrorCode: string;

    getWhitelistDetailLoading: boolean;
    getWhitelistDetailSuccess: boolean;
    getWhitelistDetailFail: boolean;
    getWhitelistDetail: WhiteListDetail[],
    getWhitelistDetailErrorCode: string;

    firePanelListLoading: boolean;
    firePanelListSuccess: boolean;
    firePanelListFail: boolean;
    firePanelList: FirePanelListData,
    firePanelListErrorCode: string;

    deviceCustomerDataLoading: boolean;
    deviceCustomerDataSuccess: boolean;
    deviceCustomerDataFail: boolean;
    deviceCustomerData: DeviceCustomerDetail,
    deviceCustomerDataErrorCode: string;

    updateCustomerDetailLoading: boolean;
    updateCustomerDetailSuccess: boolean;
    updateCustomerDetailFail: boolean;
    updateCustomerDetailErrorMessage: string;
    updateCustomerDetailId: string;

    luminaryListLoading: boolean;
    luminaryListSuccess: boolean;
    luminaryListFail: boolean;
    luminaryList: LuminaryListData,
    luminaryListErrorCode: string;

    gatewayDetailsListLoading: boolean;
    gatewayDetailsListSuccess: boolean;
    gatewayDetailsListFail: boolean;
    gatewayDetailsList: GatewayListData,
    gatewayDetailsListErrorCode: string;

    slaListLoading: boolean;
    slaListSuccess: boolean;
    slaListFail: boolean;
    slaList: SLAListData,
    slaTotalPages: number,
    slaListErrorCode: string;

    maintenanceTicketListDataLoading: boolean;
    maintenanceTicketListDataSuccess: boolean;
    maintenanceTicketListDataFail: boolean;
    maintenanceTicketListData: MaintenanceTicketDetailListData,
    maintenanceTicketListTotalPages: number,
    maintenanceTicketListErrorCode: string;

    slaCustomerListLoading: boolean;
    slaCustomerListSuccess: boolean;
    slaCustomerListFail: boolean;
    slaCustomerList: slaCustomerList,
    slaCustomerListErrorCode: string;

    configureLuminariesListLoading: boolean,
    configureLuminariesListSuccess: boolean,
    configureLuminariesListFail: boolean,
    configureLuminariesListErrorCode: string,
    configureLuminariesListDetails: ConfigureLuminaryDetailsList,

    setConfigureLuminariesListLoading: boolean,
    setConfigureLuminariesListSuccess: boolean,
    setConfigureLuminariesListFail: boolean,
    setConfigureLuminariesListErrorCode: string,
    setConfigureLuminariesMessage: string,

    getIoConfigDetailsLoading: boolean,
    getIoConfigDetailsSuccess: boolean,
    getIoConfigDetailsFail: boolean,
    getIoConfigDetailsErrorCode: string,
    getIoConfigDetails: GetIOConfigDetailsOkResponse,

    setIOConfigurationLoading: boolean,
    setIOConfigurationSuccess: boolean,
    setIOConfigurationFail: boolean,
    setIOConfigurationErrorCode: string,
    setIOConfigurationMessage: string
};

export const initialAssetState: AssetState = {
    deviceListLoading: false,
    deviceListSuccess: false,
    deviceListFail: false,
    deviceList: defaultSystemListData,
    deviceListErrorCode: '',

    deviceGetWhitelistZoneLoading: false,
    deviceGetWhitelistZoneSuccess: false,
    deviceGetWhitelistZoneFail: false,
    deviceGetWhitelistZone: defaultWhitelistZoneData,
    deviceGetWhitelistZoneErrorCode: '',

    getWhitelistDetailLoading: false,
    getWhitelistDetailSuccess: false,
    getWhitelistDetailFail: false,
    getWhitelistDetail: defaultWhiteListDetail,
    getWhitelistDetailErrorCode: '',

    whitelistzoneLoading: false,
    whitelistzoneSuccess: false,
    whitelistzoneFail: false,
    whitelistzoneErrorCode: '',
    whitelistZoneId: '',
    whitelistZoneMessage: '',

    firePanelListLoading: false,
    firePanelListSuccess: false,
    firePanelListFail: false,
    firePanelList: defaultFirePanelListData,
    firePanelListErrorCode: '',

    deviceCustomerDataLoading: false,
    deviceCustomerDataSuccess: false,
    deviceCustomerDataFail: false,
    deviceCustomerData: customerData,
    deviceCustomerDataErrorCode: '',

    updateCustomerDetailLoading: false,
    updateCustomerDetailSuccess: false,
    updateCustomerDetailFail: false,
    updateCustomerDetailErrorMessage: '',
    updateCustomerDetailId: '',

    luminaryListLoading: false,
    luminaryListSuccess: false,
    luminaryListFail: false,
    luminaryList: defaultLumListData,
    luminaryListErrorCode: '',

    gatewayDetailsListLoading: false,
    gatewayDetailsListSuccess: false,
    gatewayDetailsListFail: false,
    gatewayDetailsList: defaultGatewayListData,
    gatewayDetailsListErrorCode: '',

    slaListLoading: false,
    slaListSuccess: false,
    slaListFail: false,
    slaList: getSLAData,
    slaTotalPages: 0,
    slaListErrorCode: '',

    slaCustomerListLoading: false,
    slaCustomerListSuccess: false,
    slaCustomerListFail: false,
    slaCustomerList: [],
    slaCustomerListErrorCode: '',

    maintenanceTicketListDataLoading: false,
    maintenanceTicketListDataSuccess: false,
    maintenanceTicketListDataFail: false,
    maintenanceTicketListData: getMaintenanceTicketData,
    maintenanceTicketListTotalPages: 0,
    maintenanceTicketListErrorCode: '',

    configureLuminariesListLoading: false,
    configureLuminariesListSuccess: false,
    configureLuminariesListFail: false,
    configureLuminariesListErrorCode: '',
    configureLuminariesListDetails: defaultconfigureLumnListData,

    setConfigureLuminariesListLoading: false,
    setConfigureLuminariesListSuccess: false,
    setConfigureLuminariesListFail: false,
    setConfigureLuminariesListErrorCode: '',
    setConfigureLuminariesMessage: '',

    getIoConfigDetailsLoading: false,
    getIoConfigDetailsSuccess: false,
    getIoConfigDetailsFail: false,
    getIoConfigDetailsErrorCode: '',
    getIoConfigDetails: defaultGetIOConfigDetailsOkResponse,

    setIOConfigurationLoading: false,
    setIOConfigurationSuccess: false,
    setIOConfigurationFail: false,
    setIOConfigurationErrorCode: '',
    setIOConfigurationMessage: ''
};
